import { BaseQueryKeys } from '@amzn/gsce-shared-react-lib';

/**
 * Query key constants for audit-insight queries.
 *
 * createQuery auto-maps request params into the cache key as [collectionName, params], so
 * only the collection name is needed here for manual invalidation.
 */
export class AuditInsightsQueryKeys extends BaseQueryKeys {
  /** The stored insight for one audit, plus its live open tasks. */
  static readonly insights = 'audit-insights' as const;
}
